import { render } from "./districtmap.vue?vue&type=template&id=136efd9c&scoped=true"
import script from "./districtmap.vue?vue&type=script&lang=js"
export * from "./districtmap.vue?vue&type=script&lang=js"

import "./districtmap.vue?vue&type=style&index=0&id=136efd9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-136efd9c"]])

export default __exports__